/**
 * Copyright (c) 2018-2019 Aleksey Melnikov, True Directive Company.
 * @link https://truedirective.com/
 * @license MIT
*/
import { Component, Input, Output, EventEmitter, HostBinding,
         ChangeDetectorRef,
         ViewChild } from '@angular/core';

import { ColumnType, DetectionMode, SelectionMode } from '@true-directive/base';
import { Column } from '@true-directive/base';

import { FilterOperator, Filter } from '@true-directive/base';

import { GridSettings } from '@true-directive/base';
import { GridState } from '@true-directive/base';

import { DialogInfo } from '../../controls/dialog-info.class';

import { MenuComponent } from '../../controls/menu.component';
import { IFilter } from './filter.interface';

import { InternationalizationService } from '../../internationalization/internationalization.service';

@Component({
  selector: 'true-filter-base',
  template:``,
  styles: [``]
})
export class FilterBaseComponent implements IFilter {

  @Input() filter: Filter = null;
  @Input() rows: Array<any> = null;
  public state: GridState;

  @ViewChild('operatorMenu', {static: true}) operatorMenu: MenuComponent;

  @Output() closed: EventEmitter<any> = new EventEmitter();
  @Output() setFilter: EventEmitter<any> = new EventEmitter();
  @Output() resetFilter: EventEmitter<any> = new EventEmitter();

  public init(): void { }

  public validate(): boolean { 
    return false;
  }

  _dialog: DialogInfo = null;
  get dialog(): DialogInfo {
    if (this._dialog === null) {
      this._dialog = DialogInfo
        .new()
        .header(this.intl.translate(this.filter.caption))
        .button('set', this.intl.translate('SET'), 'primary')
        .button('reset', this.intl.translate('Reset'), 'primary outline', !this.filter.active);
    }
    return this._dialog;
  }

  public dialogBtnClick(e: any) {

    if (e.id === 'set') {
      if (this.validate()) {
        this.setFilter.emit(this.filter);
      }
    }

    if (e.id === 'reset') {
      this.resetFilter.emit(this.filter);
    }

    this.closed.emit(e);
  }

  // ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð³ÑÐ¸Ð´Ð° Ð´Ð»Ñ ÑÐ¿Ð¸ÑÐºÐ° Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹
  private _settings: GridSettings = null;
  get listSettings() {

    if (!this._settings) {
      let o = GridSettings.minimal();
      // ÐÐ¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð³ÑÑÐ¿Ð¿Ñ ÑÐ²ÑÑÐ½ÑÑÑ
      o.groupCollapseByDefault = true;
      // Ð¢Ð°ÐºÐ¾Ð¹ Ð¾ÑÑÑÑÐ¿ Ð´Ð»Ñ Ð³ÑÑÐ¿Ð¿
      o.levelIndent = 30;
      // ÐÐ¾Ð´Ð³Ð¾Ð½ÑÐµÐ¼ ÑÐ¸ÑÐ¸Ð½Ñ ÐºÐ¾Ð»Ð¾Ð½Ð¾Ðº Ð¿Ð¾Ð´ ÑÐ°Ð·Ð¼ÐµÑ Ð¾ÐºÐ½Ð°
      o.columnAutoWidth = true;
      // ÐÑÑÐ¾ÑÐ° ÑÑÑÐ¾ÐºÐ¸ Ð¸Ð· Ð½Ð°ÑÑÑÐ¾ÐµÐº
      o.rowHeight = this.state.settings.filterItemRowHeight;
      // ÐÑÐ¼ÐµÑÐ°ÐµÐ¼ ÐºÐ»Ð¸ÐºÐ¾Ð¼ Ð¿Ð¾ ÑÑÐµÐ¹ÐºÐµ, ÑÑÐ¾Ð±Ñ Ð½Ðµ ÑÐµÐ»Ð¸ÑÑÑÑ Ð² Ð¼Ð°Ð»ÐµÐ½ÑÐºÐ¸Ð¹ ÑÐµÐºÐ±Ð¾ÐºÑ
      o.checkByCellClick = true;

      o.appearance.class = this.state.settings.appearance.class;
      o.appearance.scrollboxClass = this.state.settings.appearance.scrollboxClass;

      this._settings = o;
    }
    return this._settings;
  }

  // Ð ÐµÐ¶Ð¸Ð¼
  selectMode = false;

  // ÐÑÐºÑÑÑÐ¸Ðµ Ð¼ÐµÐ½Ñ Ð²ÑÐ±Ð¾ÑÐ° Ð¾Ð¿ÐµÑÐ°ÑÐ¾ÑÐ°
  showOM(e: any) {
    if (!this.selectMode) {
      this.operatorMenu.position = 'ABSOLUTE';
      this.operatorMenu.togglePopup(e.target);
    }
    e.preventDefault();
  }

  // Ð£ÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¾Ð¿ÐµÑÐ°ÑÐ¾ÑÐ°
  operator(o: FilterOperator) {
    this.filter.operator = o;
    this.validate();
  }

  constructor(protected intl: InternationalizationService) { }
}
